import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress'; // import './App.css';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import DashboardLayout from './layouts/Dashboard/DashboardLayout';
import Login from "./pages/Auth/Login/Login";
import BillPrint from "./pages/PatientManager/BillPrint/BillPrint";
import AddBillHeaderFooter from './pages/Settings/BillHeaderFooterEditor/AddBillHeaderFooter';
import BillHeaderFooterEditor from './pages/Settings/BillHeaderFooterEditor/BillHeaderFooterEditor';
import MyEditor from './pages/Settings/BillHeaderFooterEditor/MyEditor';
import WysiwygEditor from './pages/Settings/BillHeaderFooterEditor/WysiwygEditor';


const axios = require('axios').default;



function App() {
  const dispatch = useDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [token, setToken] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [permission, setPermission] = useState("");


  axios.defaults.baseURL = `https://data.1501.rooberp.com/public/api`;
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  // axios.defaults.headers.common['Authorization'] = `Bearer 6|SSp0mwCDuElyqEovNQptPRKPzzYLbBuGeCUP6fwl`;
  axios.defaults.headers.post['Accept'] = 'application/json"';



  // authorization section 
  const validateUserToken = (token) => {
    console.log(
      "Token exist in localStorage , Here user token will be validate now", token
    );
  };
  useEffect(() => {
    const loggedinStatus = localStorage.getItem("isLoggedIn");
    const tokenValue = localStorage.getItem("token");
    const userStorageValue = localStorage.getItem("user");
    loggedinStatus && JSON.parse(loggedinStatus) ? setIsLoggedIn(true) : setIsLoggedIn(false);
    loggedinStatus && JSON.parse(loggedinStatus) ? setToken(tokenValue) : setToken("");
    loggedinStatus && JSON.parse(loggedinStatus) ? setUserInfo(userStorageValue) : setUserInfo({});
  }, []);
  useEffect(() => {

    localStorage.setItem("isLoggedIn", isLoggedIn);
    localStorage.setItem("token", token);
    localStorage.setItem("user", userInfo);

    if (JSON.stringify(userInfo) !== "{}") {
      if (token.length > 5) {
        validateUserToken(token);
      }

      // console.log("userInfo -",  JSON.parse(userInfo).permission, isLoggedIn);
      // console.log("userInfo -2-", userInfo);
      // console.log(
      //   "permission -2-",
      //   JSON.parse(userInfo).permission,
      //   typeof JSON.parse(userInfo).permission
      // );
      setPermission(JSON.parse(userInfo).permission);
      // console.log("permission - 3 - ", permission);
    }
  }, [isLoggedIn]);
  // authorization section end 
  // const handleClose = () => {
  //   setBackdropOpen(false);
  // };
  // const handleToggle = () => {
  //   setBackdropOpen(!backdropOpen);
  // };
  // const [backdropOpen, setBackdropOpen] = React.useState(false);

  const isShowBackDrop = useSelector((state) => state.isShowBackDrop);
  return (
    <>
      <div>
        {/* <Button onClick={handleToggle}>Show backdrop</Button> */}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isShowBackDrop}
          onClick={() => {
            dispatch({
              type: "isShowBackDrop_update",
              payload: false
            })
          }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      {/* {isLoggedIn && (
        <Header
          permission={permission}
          logout={() => {
            setIsLoggedIn(false);
            setUserInfo({});
            setToken("");
          }}
        />
      )} */}
      <ToastContainer />
      <Routes>
        <Route path="/bill-header-footer-editor" element={<BillHeaderFooterEditor />} />
        <Route path="/bill-editor" element={<MyEditor />} />
        <Route path="/wysiwyg-editor" element={<WysiwygEditor />} />
        <Route path="/print-2" element={<AddBillHeaderFooter />} />
        <Route path="/bill-print/:slug" element={<BillPrint />} />
        {!isLoggedIn && (
          <>
            <Route
              path="/login"
              element={
                <Login
                  authenticate={(user) => {
                    setToken(user.token);
                    setUserInfo(JSON.stringify(user.user));
                    setIsLoggedIn(true);
                  }}
                />
              }
            />
          </>
        )}

        {isLoggedIn && (
          <>
            <Route path="/" element={<DashboardLayout permission={permission}
              logout={() => {
                setIsLoggedIn(false);
                setUserInfo({});
                setToken("");
              }} />} />

            {/* <Route path="/login" element={<Login />} /> */}


            {permission === "admin" ? (
              <>
                {/* <Route path="add-user" element={<AddUser />} />
                <Route path="manage-user" element={<ManageUser />} />
                <Route path="users/:id/edit" element={<EditUser />} /> */}
              </>
            ) : (
              ""
            )}
          </>
        )}

        <Route
          path="*"
          element={<Navigate to={isLoggedIn ? "/" : "/login"} />}
        />
      </Routes>

    </>
  );
}

export default App;
